import styled from "styled-components";
import { TipMouseOutEvent, TipMouseOverEvent } from "../../../../Tooltip/Tooltip";
import VipIconImg from "../img/goldstar.png"

function ComandosVip() {
    return(
        <ColumnMaster>
                <TitleMaster>
                    <ColumItemHeaderIcon iconImg={VipIconImg}/>
	                <TitleFont>Comandos do seu acesso vip</TitleFont>
                </TitleMaster>
            
            <Line>
	            <SpanComandos
                    onMouseOver={(event) => 
                    TipMouseOverEvent(event, "Exclusivo do Plano 3 - Ifrit.", "rgb(208, 25, 25)")}
                    onMouseLeave={() => TipMouseOutEvent()}>
                    <b>@Autotrade</b> - Vende itens mesmo estando offline.
                </SpanComandos>

                <SpanComandos><b>@Mobinfo</b> - Mostra informações de um monstro desejado.</SpanComandos>
	            <SpanComandos><b>@Whodrops</b> - Mostra qual monstro dropa o item desejado.</SpanComandos>

                <SpanComandos><b>@Storage</b>    -      Acesso remoto ao armazen.</SpanComandos>
                <SpanComandos><b>@Autoloot</b> - Coleta todos os itens automaticamente.</SpanComandos>
	            <SpanComandos><b>@Alootid</b> - Coleta um item específico automaticamente.</SpanComandos>

	            <SpanComandos><b>@Identify</b> - Identifica um item mesmo sem Lupa.</SpanComandos>
                <SpanComandos><b>@Dropall</b> - Derruba todos os itens do seu inventário no chão.</SpanComandos>
                <SpanComandos><b>@Petrename</b> -  Muda o nome do seu pet.</SpanComandos>

                <SpanComandos><b>@Duel/Accept/Reject/Leave</b> - Organização de duelos.</SpanComandos>
                <SpanComandos><b>@Changeleader</b> - Muda leader do grupo.</SpanComandos>
                <SpanComandos><b>@ChangeGM</b>     -   Muda    Leader da Guild.</SpanComandos>

                <SpanComandos><b>@Guild</b> - Cria um clã sem precisar de um "Emperium".</SpanComandos>
                <SpanComandos><b>@Guildstorage</b> - Acesso remoto ao armazen do clã.</SpanComandos>
                <SpanComandos><b>@Where</b> - Encontra um personagem online.</SpanComandos>

                <SpanComandos><b>@Trade</b>   -   Realiza negociações a distância.</SpanComandos>
            </Line>
	    </ColumnMaster>
        );
    
      }

const ColumnMaster = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: space-evenly;
    //padding: 20px;
    //border: solid;
    width: 100%;
    margin-bottom: 30px;

    @media(max-width: 1000px) {
      width: 90vw;
    }
`

const Line = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    margin: 10px 0px;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    flex-wrap: wrap;
    padding: 10px;
    border-radius: 5px;

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 10px 0;
      flex-direction: column;
      margin: 5px 0px;
      align-items: center;
    }

`

const SpanComandos = styled.div`
    margin: 10px 5px;
    width: 240px;
    //box-shadow: 0px 0px 5px 0px black;
    padding: 15px 15px;
    border-radius: 5px;
    transition: .3s;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
        transform: translate(-5px,-5px);
        scale: 1.1;
    }

    @media(max-width: 1000px) {
      margin: 5px 0px;
      width: 70vw;

      &:hover {
        scale: 1.0;
        }
    }

    
`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 20px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;
    font-size: 12pt;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
    //border: solid;

    @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }
    
`


export default ComandosVip;